<script lang="ts">
  import {createForm} from 'felte';
  import {reporter} from '@felte/reporter-svelte';
  import {validator} from '@felte/validator-yup';
  import {createEventDispatcher, setContext} from 'svelte';
  import {writable, type Writable} from 'svelte/store';

  export let schema = null;
  export let initialValues = null;
  export let id: string = '';
  export let valid: boolean = false;
  export let submiting: boolean = false;
  export let warningList: unknown = null;
  /** bound to the form store isDirty which returns true when any value of the form has changed */
  export let dirty: boolean = false;
  export let isInteracted: string = null;
  export let validating: boolean = false;
  export let touchedList: unknown = null;
  export let dataStore: Writable<Object> = null;
  export let touchedStore: Writable<Object> = null;
  export let errorList: Writable<Object> = writable({});

  export const cleanDirty = () => {
    $isDirty = false;
    dirty = false;
  };

  const dispatch = createEventDispatcher<{
    submit: {data: Object; errors: Object};
    input: void;
  }>();

  const onSubmit = (): void => {
    dispatch('submit', {data: $data, errors: $errors});
  };

  const handleInput = () => {
    dispatch('input');
  };

  // definition of each of this stores (ex. warnings, touched, isValid, etc)
  // are located in https://felte.dev/docs/svelte/stores
  const {
    form,
    data,
    errors,
    setFields,
    warnings,
    touched,
    isValid,
    isSubmitting,
    isDirty,
    isValidating,
    interacted,
    validate,
    setData,
  } = createForm({
    initialValues,
    onSubmit,
    extend: [validator({schema}), reporter],
  });

  $: valid = $isValid;
  // isValid return true when the form is valid
  $: submiting = $isSubmitting;
  // isSubmitting return true when the form is submitting
  $: warningList = $warnings;
  // warnings return a list of warnings
  $: dirty = $isDirty;
  // isDirty return true when the form is dirty
  $: isInteracted = $interacted;
  // interacted return the name of the field that was interacted
  $: validating = $isValidating;
  // isValidating return true when the form is validating
  $: touchedList = $touched;
  // touched return a list of touched fields

  $: errorList.set($errors);

  setContext('formManager', {errors, setFields});
  export const validateForm = validate;
  export const setFormData = setData;
  export const setFormFields = setFields;

  $: dataStore = data;
  $: touchedStore = touched;
</script>

<form
  use:form
  data-testid="form-{id}"
  {id}
  class={$$props.class}
  on:input={handleInput}
>
  <slot />
</form>
